import layout from '@/views/layout/layout.vue'
const serviceOrderList = r => require.ensure([], () => r(require('@/views/ywt/serviceOrder/list.vue')), 'group-ywt-member')

const ywtServiceOrder = [
  {
    path: '/ywt/serviceOrder',
    name: 'ywt-serviceOrder',
    component: layout,
    redirect: '/ywt/serviceOrder/list',
    children: [
      {
        path: 'list',
        name: 'ywt-serviceOrder-list',
        component: serviceOrderList,
        meta: {
          displayName: '维修管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtServiceOrder



// WEBPACK FOOTER //
// ./src/router/ywt/serviceOrder.js